import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BackToHomeComponent } from '../../../back-to-home/back-to-home.component';

@Component({
    selector: 'awo-terms',
    imports: [BackToHomeComponent],
    template: `
  <div class="terms-container">
    <h1 i18n="@@footer.terms.title">Allgemeine Geschäftsbedingungen</h1>
    <p i18n="@@footer.terms.placeholder">AGB folgen in Kürze.</p>
    <awo-care-back-to-home />
  </div>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: [
        `
        :host {
          display: block;
          max-width: 800px;
          margin: 0 auto;
          padding: 2rem;
        }
        `
    ]
})
export class TermsComponent { }